export function createStar() {
    const star = document.createElement('div');
    star.className = 'star';
    const size = Math.random() * 3 + 1.4;
    star.style.width = `${size}px`;
    star.style.height = `${size}px`;
    star.style.left = `${Math.random() * 100}%`;
    star.style.top = `${Math.random() * 100}%`;
    star.style.animationDuration = `${Math.random() * 50 + 50}s`;
    return star;
  }
  
  export function initStars() {
    const container = document.getElementById('stars-container');
    for (let i = 0; i < 100; i++) {
      container.appendChild(createStar());
    }
  }
  